const fourDigitTeaors = [
  {
    labelText: `0111 '08 Gabonaféle (kivéve: rizs), hüvelyes növény, olajos mag termesztése`,
    teaorValue: '0111'
  },
  {
    labelText: `0112 '08 Rizstermesztés`,
    teaorValue: '0112'
  },
  {
    labelText: `0113 '08 Zöldségféle, dinnye, gyökér-, gumósnövény termesztése`,
    teaorValue: '0113'
  },
  {
    labelText: `0114 '08 Cukornádtermesztés`,
    teaorValue: '0114'
  },
  {
    labelText: `0115 '08 Dohánytermesztés`,
    teaorValue: '0115'
  },
  {
    labelText: `0116 '08 Rostnövénytermesztés`,
    teaorValue: '0116'
  },
  {
    labelText: `0119 '08 Egyéb, nem évelő növény termesztése`,
    teaorValue: '0119'
  },
  {
    labelText: `0121 '08 Szőlőtermesztés`,
    teaorValue: '0121'
  },
  {
    labelText: `0122 '08 Trópusi gyümölcs termesztése`,
    teaorValue: '0122'
  },
  {
    labelText: `0123 '08 Citrusféle termesztése`,
    teaorValue: '0123'
  },
  {
    labelText: `0124 '08 Almatermésű, csonthéjas termesztése`,
    teaorValue: '0124'
  },
  {
    labelText: `0125 '08 Egyéb gyümölcs, héjastermésű termesztése`,
    teaorValue: '0125'
  },
  {
    labelText: `0126 '08 Olajtartalmú gyümölcs termesztése`,
    teaorValue: '0126'
  },
  {
    labelText: `0127 '08 Italgyártási növény termesztése`,
    teaorValue: '0127'
  },
  {
    labelText: `0128 '08 Fűszer-, aroma-, narkotikus, gyógynövény termesztése`,
    teaorValue: '0128'
  },
  {
    labelText: `0129 '08 Egyéb évelő növény termesztése`,
    teaorValue: '0129'
  },
  {
    labelText: `0130 '08 Növényi szaporítóanyag termesztése`,
    teaorValue: '0130'
  },
  {
    labelText: `0141 '08 Tejhasznú szarvasmarha tenyésztése`,
    teaorValue: '0141'
  },
  {
    labelText: `0142 '08 Egyéb szarvasmarha tenyésztése`,
    teaorValue: '0142'
  },
  {
    labelText: `0143 '08 Ló, lóféle tenyésztése`,
    teaorValue: '0143'
  },
  {
    labelText: `0144 '08 Teve, teveféle tenyésztése`,
    teaorValue: '0144'
  },
  {
    labelText: `0145 '08 Juh, kecske tenyésztése`,
    teaorValue: '0145'
  },
  {
    labelText: `0146 '08 Sertéstenyésztés`,
    teaorValue: '0146'
  },
  {
    labelText: `0147 '08 Baromfitenyésztés`,
    teaorValue: '0147'
  },
  {
    labelText: `0149 '08 Egyéb állat tenyésztése`,
    teaorValue: '0149'
  },
  {
    labelText: `0150 '08 Vegyes gazdálkodás`,
    teaorValue: '0150'
  },
  {
    labelText: `0161 '08 Növénytermesztési szolgáltatás`,
    teaorValue: '0161'
  },
  {
    labelText: `0162 '08 Állattenyésztési szolgáltatás`,
    teaorValue: '0162'
  },
  {
    labelText: `0163 '08 Betakarítást követő szolgáltatás`,
    teaorValue: '0163'
  },
  {
    labelText: `0164 '08 Vetési célú magfeldolgozás`,
    teaorValue: '0164'
  },
  {
    labelText: `0170 '08 Vadgazdálkodás, vadgazdálkodási szolgáltatás`,
    teaorValue: '0170'
  },
  {
    labelText: `0210 '08 Erdészeti, egyéb erdőgazdálkodási tevékenység`,
    teaorValue: '0210'
  },
  {
    labelText: `0220 '08 Fakitermelés`,
    teaorValue: '0220'
  },
  {
    labelText: `0230 '08 Vadon termő egyéb erdei termék gyűjtése`,
    teaorValue: '0230'
  },
  {
    labelText: `0240 '08 Erdészeti szolgáltatás`,
    teaorValue: '0240'
  },
  {
    labelText: `0311 '08 Tengeri halászat`,
    teaorValue: '0311'
  },
  {
    labelText: `0312 '08 Édesvízi halászat`,
    teaorValue: '0312'
  },
  {
    labelText: `0321 '08 Tengerihal-gazdálkodás`,
    teaorValue: '0321'
  },
  {
    labelText: `0322 '08 Édesvízihal-gazdálkodás`,
    teaorValue: '0322'
  },
  {
    labelText: `0510 '08 Feketeszén-bányászat`,
    teaorValue: '0510'
  },
  {
    labelText: `0520 '08 Barnaszén-, lignitbányászat`,
    teaorValue: '0520'
  },
  {
    labelText: `0610 '08 Kőolaj-kitermelés`,
    teaorValue: '0610'
  },
  {
    labelText: `0620 '08 Földgázkitermelés`,
    teaorValue: '0620'
  },
  {
    labelText: `0710 '08 Vasércbányászat`,
    teaorValue: '0710'
  },
  {
    labelText: `0721 '08 Urán-, tóriumérc-bányászat`,
    teaorValue: '0721'
  },
  {
    labelText: `0729 '08 Színesfém érc bányászata`,
    teaorValue: '0729'
  },
  {
    labelText: `0811 '08 Kőfejtés, gipsz, kréta bányászata`,
    teaorValue: '0811'
  },
  {
    labelText: `0812 '08 Kavics-, homok-, agyagbányászat`,
    teaorValue: '0812'
  },
  {
    labelText: `0891 '08 Vegyi ásvány bányászata`,
    teaorValue: '0891'
  },
  {
    labelText: `0892 '08 Tőzegkitermelés`,
    teaorValue: '0892'
  },
  {
    labelText: `0893 '08 Sókitermelés`,
    teaorValue: '0893'
  },
  {
    labelText: `0899 '08 Egyéb m.n.s. bányászat`,
    teaorValue: '0899'
  },
  {
    labelText: `0910 '08 Kőolaj-, földgáz-kitermelési szolgáltatás`,
    teaorValue: '0910'
  },
  {
    labelText: `0990 '08 Egyéb bányászati szolgáltatás`,
    teaorValue: '0990'
  },
  {
    labelText: `1011 '08 Húsfeldolgozás, -tartósítás`,
    teaorValue: '1011'
  },
  {
    labelText: `1012 '08 Baromfihús feldolgozása, tartósítása`,
    teaorValue: '1012'
  },
  {
    labelText: `1013 '08 Hús-, baromfihús-készítmény gyártása`,
    teaorValue: '1013'
  },
  {
    labelText: `1020 '08 Halfeldolgozás, -tartósítás`,
    teaorValue: '1020'
  },
  {
    labelText: `1031 '08 Burgonyafeldolgozás, -tartósítás`,
    teaorValue: '1031'
  },
  {
    labelText: `1032 '08 Gyümölcs-, zöldséglé gyártása`,
    teaorValue: '1032'
  },
  {
    labelText: `1039 '08 Egyéb gyümölcs-, zöldségfeldolgozás, -tartósítás`,
    teaorValue: '1039'
  },
  {
    labelText: `1041 '08 Olaj gyártása`,
    teaorValue: '1041'
  },
  {
    labelText: `1042 '08 Margarin gyártása`,
    teaorValue: '1042'
  },
  {
    labelText: `1051 '08 Tejtermék gyártása`,
    teaorValue: '1051'
  },
  {
    labelText: `1052 '08 Jégkrém gyártása`,
    teaorValue: '1052'
  },
  {
    labelText: `1061 '08 Malomipari termék gyártása`,
    teaorValue: '1061'
  },
  {
    labelText: `1062 '08 Keményítő, keményítőtermék gyártása`,
    teaorValue: '1062'
  },
  {
    labelText: `1071 '08 Kenyér; friss pékáru gyártása`,
    teaorValue: '1071'
  },
  {
    labelText: `1072 '08 Tartósított lisztes áru gyártása`,
    teaorValue: '1072'
  },
  {
    labelText: `1073 '08 Tésztafélék gyártása`,
    teaorValue: '1073'
  },
  {
    labelText: `1081 '08 Cukorgyártás`,
    teaorValue: '1081'
  },
  {
    labelText: `1082 '08 Édesség gyártása`,
    teaorValue: '1082'
  },
  {
    labelText: `1083 '08 Tea, kávé feldolgozása`,
    teaorValue: '1083'
  },
  {
    labelText: `1084 '08 Fűszer, ételízesítő gyártása`,
    teaorValue: '1084'
  },
  {
    labelText: `1085 '08 Készétel gyártása`,
    teaorValue: '1085'
  },
  {
    labelText: `1086 '08 Homogenizált, diétás étel gyártása`,
    teaorValue: '1086'
  },
  {
    labelText: `1089 '08 M.n.s. egyéb élelmiszer gyártása`,
    teaorValue: '1089'
  },
  {
    labelText: `1091 '08 Haszonállat-eledel gyártása`,
    teaorValue: '1091'
  },
  {
    labelText: `1092 '08 Hobbiállat-eledel gyártása`,
    teaorValue: '1092'
  },
  {
    labelText: `1101 '08 Desztillált szeszes ital gyártása`,
    teaorValue: '1101'
  },
  {
    labelText: `1102 '08 Szőlőbor termelése`,
    teaorValue: '1102'
  },
  {
    labelText: `1103 '08 Gyümölcsbor termelése`,
    teaorValue: '1103'
  },
  {
    labelText: `1104 '08 Egyéb nem desztillált, erjesztett ital gyártása`,
    teaorValue: '1104'
  },
  {
    labelText: `1105 '08 Sörgyártás`,
    teaorValue: '1105'
  },
  {
    labelText: `1106 '08 Malátagyártás`,
    teaorValue: '1106'
  },
  {
    labelText: `1107 '08 Üdítőital, ásványvíz gyártása`,
    teaorValue: '1107'
  },
  {
    labelText: `1200 '08 Dohánytermék gyártása`,
    teaorValue: '1200'
  },
  {
    labelText: `1310 '08 Textilszálak fonása`,
    teaorValue: '1310'
  },
  {
    labelText: `1320 '08 Textilszövés`,
    teaorValue: '1320'
  },
  {
    labelText: `1330 '08 Textilkikészítés`,
    teaorValue: '1330'
  },
  {
    labelText: `1391 '08 Kötött, hurkolt kelme gyártása`,
    teaorValue: '1391'
  },
  {
    labelText: `1392 '08 Konfekcionált textiláru gyártása (kivéve: ruházat)`,
    teaorValue: '1392'
  },
  {
    labelText: `1393 '08 Szőnyeggyártás`,
    teaorValue: '1393'
  },
  {
    labelText: `1394 '08 Kötéláru gyártása`,
    teaorValue: '1394'
  },
  {
    labelText: `1395 '08 Nem szőtt textília és termék gyártása (kivéve: ruházat)`,
    teaorValue: '1395'
  },
  {
    labelText: `1396 '08 Műszaki textiláru gyártása`,
    teaorValue: '1396'
  },
  {
    labelText: `1399 '08 Egyéb textiláru gyártása m.n.s.`,
    teaorValue: '1399'
  },
  {
    labelText: `1411 '08 Bőrruházat gyártása`,
    teaorValue: '1411'
  },
  {
    labelText: `1412 '08 Munkaruházat gyártása`,
    teaorValue: '1412'
  },
  {
    labelText: `1413 '08 Felsőruházat gyártása (kivéve: munkaruházat)`,
    teaorValue: '1413'
  },
  {
    labelText: `1414 '08 Alsóruházat gyártása`,
    teaorValue: '1414'
  },
  {
    labelText: `1419 '08 Egyéb ruházat, kiegészítők gyártása`,
    teaorValue: '1419'
  },
  {
    labelText: `1420 '08 Szőrmecikk gyártása`,
    teaorValue: '1420'
  },
  {
    labelText: `1431 '08 Kötött, hurkolt harisnyafélék gyártása`,
    teaorValue: '1431'
  },
  {
    labelText: `1439 '08 Egyéb kötött, hurkolt ruházati termék gyártása`,
    teaorValue: '1439'
  },
  {
    labelText: `1511 '08 Bőr, szőrme kikészítése`,
    teaorValue: '1511'
  },
  {
    labelText: `1512 '08 Táskafélék, szíjazat gyártása`,
    teaorValue: '1512'
  },
  {
    labelText: `1520 '08 Lábbeligyártás`,
    teaorValue: '1520'
  },
  {
    labelText: `1610 '08 Fűrészárugyártás`,
    teaorValue: '1610'
  },
  {
    labelText: `1621 '08 Falemezgyártás`,
    teaorValue: '1621'
  },
  {
    labelText: `1622 '08 Parkettagyártás`,
    teaorValue: '1622'
  },
  {
    labelText: `1623 '08 Épületasztalos-ipari termék gyártása`,
    teaorValue: '1623'
  },
  {
    labelText: `1624 '08 Tároló fatermék gyártása`,
    teaorValue: '1624'
  },
  {
    labelText: `1629 '08 Egyéb fa-, parafatermék, fonottáru gyártása`,
    teaorValue: '1629'
  },
  {
    labelText: `1711 '08 Papíripari rostanyag gyártása`,
    teaorValue: '1711'
  },
  {
    labelText: `1712 '08 Papírgyártás`,
    teaorValue: '1712'
  },
  {
    labelText: `1721 '08 Papír csomagolóeszköz gyártása`,
    teaorValue: '1721'
  },
  {
    labelText: `1722 '08 Háztartási, egészségügyi papírtermék gyártása`,
    teaorValue: '1722'
  },
  {
    labelText: `1723 '08 Irodai papíráru gyártása`,
    teaorValue: '1723'
  },
  {
    labelText: `1724 '08 Tapétagyártás`,
    teaorValue: '1724'
  },
  {
    labelText: `1729 '08 Egyéb papír-, kartontermék gyártása`,
    teaorValue: '1729'
  },
  {
    labelText: `1811 '08 Napilapnyomás`,
    teaorValue: '1811'
  },
  {
    labelText: `1812 '08 Nyomás (kivéve: napilap)`,
    teaorValue: '1812'
  },
  {
    labelText: `1813 '08 Nyomdai előkészítő tevékenység`,
    teaorValue: '1813'
  },
  {
    labelText: `1814 '08 Könyvkötés, kapcsolódó szolgáltatás`,
    teaorValue: '1814'
  },
  {
    labelText: `1820 '08 Egyéb sokszorosítás`,
    teaorValue: '1820'
  },
  {
    labelText: `1910 '08 Kokszgyártás`,
    teaorValue: '1910'
  },
  {
    labelText: `1920 '08 Kőolaj-feldolgozás`,
    teaorValue: '1920'
  },
  {
    labelText: `2011 '08 Ipari gáz gyártása`,
    teaorValue: '2011'
  },
  {
    labelText: `2012 '08 Színezék, pigment gyártása`,
    teaorValue: '2012'
  },
  {
    labelText: `2013 '08 Szervetlen vegyi alapanyag gyártása`,
    teaorValue: '2013'
  },
  {
    labelText: `2014 '08 Szerves vegyi alapanyag gyártása`,
    teaorValue: '2014'
  },
  {
    labelText: `2015 '08 Műtrágya, nitrogénvegyület gyártása`,
    teaorValue: '2015'
  },
  {
    labelText: `2016 '08 Műanyag-alapanyag gyártása`,
    teaorValue: '2016'
  },
  {
    labelText: `2017 '08 Szintetikus kaucsuk alapanyag gyártása`,
    teaorValue: '2017'
  },
  {
    labelText: `2020 '08 Mezőgazdasági vegyi termék gyártása`,
    teaorValue: '2020'
  },
  {
    labelText: `2030 '08 Festék, bevonóanyag gyártása`,
    teaorValue: '2030'
  },
  {
    labelText: `2041 '08 Tisztítószer gyártása`,
    teaorValue: '2041'
  },
  {
    labelText: `2042 '08 Testápolási cikk gyártása`,
    teaorValue: '2042'
  },
  {
    labelText: `2051 '08 Robbanóanyag gyártása`,
    teaorValue: '2051'
  },
  {
    labelText: `2052 '08 Ragasztószergyártás`,
    teaorValue: '2052'
  },
  {
    labelText: `2053 '08 Illóolajgyártás`,
    teaorValue: '2053'
  },
  {
    labelText: `2059 '08 M.n.s. egyéb vegyi termék gyártása`,
    teaorValue: '2059'
  },
  {
    labelText: `2060 '08 Vegyi szál gyártása`,
    teaorValue: '2060'
  },
  {
    labelText: `2110 '08 Gyógyszeralapanyag-gyártás`,
    teaorValue: '2110'
  },
  {
    labelText: `2120 '08 Gyógyszerkészítmény gyártása`,
    teaorValue: '2120'
  },
  {
    labelText: `2211 '08 Gumiabroncs, gumitömlő gyártása`,
    teaorValue: '2211'
  },
  {
    labelText: `2219 '08 Egyéb gumitermék gyártása`,
    teaorValue: '2219'
  },
  {
    labelText: `2221 '08 Műanyag lap, lemez, fólia, cső, profil gyártása`,
    teaorValue: '2221'
  },
  {
    labelText: `2222 '08 Műanyag csomagolóeszköz gyártása`,
    teaorValue: '2222'
  },
  {
    labelText: `2223 '08 Műanyag építőanyag gyártása`,
    teaorValue: '2223'
  },
  {
    labelText: `2229 '08 Egyéb műanyag termék gyártása`,
    teaorValue: '2229'
  },
  {
    labelText: `2311 '08 Síküveggyártás`,
    teaorValue: '2311'
  },
  {
    labelText: `2312 '08 Síküveg továbbfeldolgozása`,
    teaorValue: '2312'
  },
  {
    labelText: `2313 '08 Öblösüveggyártás`,
    teaorValue: '2313'
  },
  {
    labelText: `2314 '08 Üvegszálgyártás`,
    teaorValue: '2314'
  },
  {
    labelText: `2319 '08 Műszaki, egyéb üvegtermék gyártása`,
    teaorValue: '2319'
  },
  {
    labelText: `2320 '08 Tűzálló termék gyártása`,
    teaorValue: '2320'
  },
  {
    labelText: `2331 '08 Kerámiacsempe, -lap gyártása`,
    teaorValue: '2331'
  },
  {
    labelText: `2332 '08 Égetett agyag építőanyag gyártása`,
    teaorValue: '2332'
  },
  {
    labelText: `2341 '08 Háztartási kerámia gyártása`,
    teaorValue: '2341'
  },
  {
    labelText: `2342 '08 Egészségügyi kerámia gyártása`,
    teaorValue: '2342'
  },
  {
    labelText: `2343 '08 Kerámia szigetelő gyártása`,
    teaorValue: '2343'
  },
  {
    labelText: `2344 '08 Műszaki kerámia gyártása`,
    teaorValue: '2344'
  },
  {
    labelText: `2349 '08 Egyéb kerámiatermék gyártása`,
    teaorValue: '2349'
  },
  {
    labelText: `2351 '08 Cementgyártás`,
    teaorValue: '2351'
  },
  {
    labelText: `2352 '08 Mész-, gipszgyártás`,
    teaorValue: '2352'
  },
  {
    labelText: `2361 '08 Építé si betontermék gyártása`,
    teaorValue: '2361'
  },
  {
    labelText: `2362 '08 Építési gipsztermék gyártása`,
    teaorValue: '2362'
  },
  {
    labelText: `2363 '08 Előre kevert beton gyártása`,
    teaorValue: '2363'
  },
  {
    labelText: `2364 '08 Habarcsgyártás`,
    teaorValue: '2364'
  },
  {
    labelText: `2365 '08 Szálerősítésű cement gyártása`,
    teaorValue: '2365'
  },
  {
    labelText: `2369 '08 Egyéb beton-, gipsz-, cementtermék gyártása`,
    teaorValue: '2369'
  },
  {
    labelText: `2370 '08 Kőmegmunkálás`,
    teaorValue: '2370'
  },
  {
    labelText: `2391 '08 Csiszolótermék gyártása`,
    teaorValue: '2391'
  },
  {
    labelText: `2399 '08 M.n.s. egyéb nemfém ásványi termék gyártása`,
    teaorValue: '2399'
  },
  {
    labelText: `2410 '08 Vas-, acél-, vasötvözet-alapanyag gyártása`,
    teaorValue: '2410'
  },
  {
    labelText: `2420 '08 Acélcsőgyártás`,
    teaorValue: '2420'
  },
  {
    labelText: `2431 '08 Hidegen húzott acélrúd gyártása`,
    teaorValue: '2431'
  },
  {
    labelText: `2432 '08 Hidegen hengerelt keskeny acélszalag gyártása`,
    teaorValue: '2432'
  },
  {
    labelText: `2433 '08 Hidegen hajlított acélidom gyártása`,
    teaorValue: '2433'
  },
  {
    labelText: `2434 '08 Hidegen húzott acélhuzal gyártása`,
    teaorValue: '2434'
  },
  {
    labelText: `2441 '08 Nemesfémgyártás`,
    teaorValue: '2441'
  },
  {
    labelText: `2442 '08 Alumíniumgyártás`,
    teaorValue: '2442'
  },
  {
    labelText: `2443 '08 Ólom, cink, ón gyártása`,
    teaorValue: '2443'
  },
  {
    labelText: `2444 '08 Rézgyártás`,
    teaorValue: '2444'
  },
  {
    labelText: `2445 '08 Egyéb nem vas fém gyártása`,
    teaorValue: '2445'
  },
  {
    labelText: `2446 '08 Nukleáris fűtőanyag gyártása`,
    teaorValue: '2446'
  },
  {
    labelText: `2451 '08 Vasöntés`,
    teaorValue: '2451'
  },
  {
    labelText: `2452 '08 Acélöntés`,
    teaorValue: '2452'
  },
  {
    labelText: `2453 '08 Könnyűfémöntés`,
    teaorValue: '2453'
  },
  {
    labelText: `2454 '08 Egyéb nem vas fém öntése`,
    teaorValue: '2454'
  },
  {
    labelText: `2511 '08 Fémszerkezet gyártása`,
    teaorValue: '2511'
  },
  {
    labelText: `2512 '08 Fém épületelem gyártása`,
    teaorValue: '2512'
  },
  {
    labelText: `2521 '08 Központi fűtési kazán, radiátor gyártása`,
    teaorValue: '2521'
  },
  {
    labelText: `2529 '08 Fémtartály gyártása`,
    teaorValue: '2529'
  },
  {
    labelText: `2530 '08 Gőzkazán gyártása`,
    teaorValue: '2530'
  },
  {
    labelText: `2540 '08 Fegyver-, lőszergyártás`,
    teaorValue: '2540'
  },
  {
    labelText: `2550 '08 Fémalakítás, porkohászat`,
    teaorValue: '2550'
  },
  {
    labelText: `2561 '08 Fémfelület-kezelés`,
    teaorValue: '2561'
  },
  {
    labelText: `2562 '08 Fémmegmunkálás`,
    teaorValue: '2562'
  },
  {
    labelText: `2571 '08 Evőeszköz gyártása`,
    teaorValue: '2571'
  },
  {
    labelText: `2572 '08 Lakat-, zárgyártás`,
    teaorValue: '2572'
  },
  {
    labelText: `2573 '08 Szerszámgyártás`,
    teaorValue: '2573'
  },
  {
    labelText: `2591 '08 Acél tárolóeszköz gyártása`,
    teaorValue: '2591'
  },
  {
    labelText: `2592 '08 Könnyűfém csomagolóeszköz gyártása`,
    teaorValue: '2592'
  },
  {
    labelText: `2593 '08 Huzaltermék gyártása`,
    teaorValue: '2593'
  },
  {
    labelText: `2594 '08 Kötőelem, csavar gyártása`,
    teaorValue: '2594'
  },
  {
    labelText: `2599 '08 M.n.s. egyéb fémfeldolgozási termék gyártása`,
    teaorValue: '2599'
  },
  {
    labelText: `2611 '08 Elektronikai alkatrész gyártása`,
    teaorValue: '2611'
  },
  {
    labelText: `2612 '08 Elektronikai áramköri kártya gyártása`,
    teaorValue: '2612'
  },
  {
    labelText: `2620 '08 Számítógép, perifériás egység gyártása`,
    teaorValue: '2620'
  },
  {
    labelText: `2630 '08 Híradás-technikai berendezés gyártása`,
    teaorValue: '2630'
  },
  {
    labelText: `2640 '08 Elektronikus fogyasztási cikk gyártása`,
    teaorValue: '2640'
  },
  {
    labelText: `2651 '08 Mérőműszergyártás`,
    teaorValue: '2651'
  },
  {
    labelText: `2652 '08 Óragyártás`,
    teaorValue: '2652'
  },
  {
    labelText: `2660 '08 Elektronikus orvosi berendezés gyártása`,
    teaorValue: '2660'
  },
  {
    labelText: `2670 '08 Optikai eszköz gyártása`,
    teaorValue: '2670'
  },
  {
    labelText: `2680 '08 Mágneses, optikai információhordozó gyártása`,
    teaorValue: '2680'
  },
  {
    labelText: `2711 '08 Villamos motor, áramfejlesztő gyártása`,
    teaorValue: '2711'
  },
  {
    labelText: `2712 '08 Áramelosztó, -szabályozó készülék gyártása`,
    teaorValue: '2712'
  },
  {
    labelText: `2720 '08 Akkumulátor, szárazelem gyártása`,
    teaorValue: '2720'
  },
  {
    labelText: `2731 '08 Száloptikai kábel gyártása`,
    teaorValue: '2731'
  },
  {
    labelText: `2732 '08 Egyéb elektronikus, villamos vezeték, kábel gyártása`,
    teaorValue: '2732'
  },
  {
    labelText: `2733 '08 Szerelvény gyártása`,
    teaorValue: '2733'
  },
  {
    labelText: `2740 '08 Villamos világítóeszköz gyártása`,
    teaorValue: '2740'
  },
  {
    labelText: `2751 '08 Háztartási villamos készülék gyártása`,
    teaorValue: '2751'
  },
  {
    labelText: `2752 '08 Nem villamos háztartási készülék gyártása`,
    teaorValue: '2752'
  },
  {
    labelText: `2790 '08 Egyéb villamos berendezés gyártása`,
    teaorValue: '2790'
  },
  {
    labelText: `2811 '08 Motor, turbina gyártása (kivéve: légi, közútijármű-motor)`,
    teaorValue: '2811'
  },
  {
    labelText: `2812 '08 Hidraulikus, pneumatikus berendezés gyártása`,
    teaorValue: '2812'
  },
  {
    labelText: `2813 '08 Egyéb szivattyú, kompresszor gyártása`,
    teaorValue: '2813'
  },
  {
    labelText: `2814 '08 Csap, szelep gyártása`,
    teaorValue: '2814'
  },
  {
    labelText: `2815 '08 Csapágy, erőátviteli elem gyártása`,
    teaorValue: '2815'
  },
  {
    labelText: `2821 '08 Fűtőberendezés, kemence gyártása`,
    teaorValue: '2821'
  },
  {
    labelText: `2822 '08 Emelő-, anyagmozgató gép gyártása`,
    teaorValue: '2822'
  },
  {
    labelText: `2823 '08 Irodagép gyártása (kivéve: számítógép és perifériái)`,
    teaorValue: '2823'
  },
  {
    labelText: `2824 '08 Gépi meghajtású hordozható kézi szerszámgép gyártása`,
    teaorValue: '2824'
  },
  {
    labelText: `2825 '08 Nem háztartási hűtő, légállapot-szabályozó gyártása`,
    teaorValue: '2825'
  },
  {
    labelText: `2829 '08 M.n.s. egyéb általános rendeltetésű gép gyártása`,
    teaorValue: '2829'
  },
  {
    labelText: `2830 '08 Mezőgazdasági, erdészeti gép gyártása`,
    teaorValue: '2830'
  },
  {
    labelText: `2841 '08 Fémmegmunkáló szerszámgép gyártása`,
    teaorValue: '2841'
  },
  {
    labelText: `2849 '08 Egyéb szerszámgép gyártása`,
    teaorValue: '2849'
  },
  {
    labelText: `2891 '08 Kohászati gép gyártása`,
    teaorValue: '2891'
  },
  {
    labelText: `2892 '08 Bányászati, építőipari gép gyártása`,
    teaorValue: '2892'
  },
  {
    labelText: `2893 '08 Élelmiszer-, dohányipari gép gyártása`,
    teaorValue: '2893'
  },
  {
    labelText: `2894 '08 Textil-, ruházati, bőripari gép gyártása`,
    teaorValue: '2894'
  },
  {
    labelText: `2895 '08 Papíripari gép gyártása`,
    teaorValue: '2895'
  },
  {
    labelText: `2896 '08 Műanyag-, gumifeldolgozó gép gyártása`,
    teaorValue: '2896'
  },
  {
    labelText: `2899 '08 M.n.s. egyéb speciális gép gyártása`,
    teaorValue: '2899'
  },
  {
    labelText: `2910 '08 Közúti gépjármű gyártása`,
    teaorValue: '2910'
  },
  {
    labelText: `2920 '08 Gépjármű-karosszéria, pótkocsi gyártása`,
    teaorValue: '2920'
  },
  {
    labelText: `2931 '08 Járművillamossági, -elektronikai készülékek gyártása`,
    teaorValue: '2931'
  },
  {
    labelText: `2932 '08 Közúti jármű, járműmotor alkatrészeinek gyártása`,
    teaorValue: '2932'
  },
  {
    labelText: `3011 '08 Hajógyártás`,
    teaorValue: '3011'
  },
  {
    labelText: `3012 '08 Szabadidő-, sporthajó gyártása`,
    teaorValue: '3012'
  },
  {
    labelText: `3020 '08 Vasúti, kötöttpályás jármű gyártása`,
    teaorValue: '3020'
  },
  {
    labelText: `3030 '08 Légi, űrjármű gyártása`,
    teaorValue: '3030'
  },
  {
    labelText: `3040 '08 Katonai harcjármű gyártása`,
    teaorValue: '3040'
  },
  {
    labelText: `3091 '08 Motorkerékpár gyártása`,
    teaorValue: '3091'
  },
  {
    labelText: `3092 '08 Kerékpár, mozgássérültkocsi gyártása`,
    teaorValue: '3092'
  },
  {
    labelText: `3099 '08 M.n.s. egyéb jármű gyártása`,
    teaorValue: '3099'
  },
  {
    labelText: `3101 '08 Irodabútor gyártása`,
    teaorValue: '3101'
  },
  {
    labelText: `3102 '08 Konyhabútorgyártás`,
    teaorValue: '3102'
  },
  {
    labelText: `3103 '08 Ágybetét gyártása`,
    teaorValue: '3103'
  },
  {
    labelText: `3109 '08 Egyéb bútor gyártása`,
    teaorValue: '3109'
  },
  {
    labelText: `3211 '08 Érmegyártás`,
    teaorValue: '3211'
  },
  {
    labelText: `3212 '08 Ékszergyártás`,
    teaorValue: '3212'
  },
  {
    labelText: `3213 '08 Divatékszer gyártása`,
    teaorValue: '3213'
  },
  {
    labelText: `3220 '08 Hangszergyártás`,
    teaorValue: '3220'
  },
  {
    labelText: `3230 '08 Sportszergyártás`,
    teaorValue: '3230'
  },
  {
    labelText: `3240 '08 Játékgyártás`,
    teaorValue: '3240'
  },
  {
    labelText: `3250 '08 Orvosi eszköz gyártása`,
    teaorValue: '3250'
  },
  {
    labelText: `3291 '08 Seprű-, kefegyártás`,
    teaorValue: '3291'
  },
  {
    labelText: `3299 '08 Egyéb m.n.s feldolgozóipari tevékenység`,
    teaorValue: '3299'
  },
  {
    labelText: `3311 '08 Fémfeldolgozási termék javítása`,
    teaorValue: '3311'
  },
  {
    labelText: `3312 '08 Ipari gép, berendezés javítása`,
    teaorValue: '3312'
  },
  {
    labelText: `3313 '08 Elektronikus, optikai eszköz javítása`,
    teaorValue: '3313'
  },
  {
    labelText: `3314 '08 Ipari villamos gép, berendezés javítása`,
    teaorValue: '3314'
  },
  {
    labelText: `3315 '08 Hajó, csónak javítása`,
    teaorValue: '3315'
  },
  {
    labelText: `3316 '08 Repülőgép, űrhajó javítása`,
    teaorValue: '3316'
  },
  {
    labelText: `3317 '08 Egyéb közlekedési eszköz javítása`,
    teaorValue: '3317'
  },
  {
    labelText: `3319 '08 Egyéb ipari eszköz javítása`,
    teaorValue: '3319'
  },
  {
    labelText: `3320 '08 Ipari gép, berendezés üzembe helyezése`,
    teaorValue: '3320'
  },
  {
    labelText: `3511 '08 Villamosenergia-termelés`,
    teaorValue: '3511'
  },
  {
    labelText: `3512 '08 Villamosenergia-szállítás`,
    teaorValue: '3512'
  },
  {
    labelText: `3513 '08 Villamosenergia-elosztás`,
    teaorValue: '3513'
  },
  {
    labelText: `3514 '08 Villamosenergia-kereskedelem`,
    teaorValue: '3514'
  },
  {
    labelText: `3521 '08 Gázgyártás`,
    teaorValue: '3521'
  },
  {
    labelText: `3522 '08 Gázelosztás`,
    teaorValue: '3522'
  },
  {
    labelText: `3523 '08 Gázkereskedelem`,
    teaorValue: '3523'
  },
  {
    labelText: `3530 '08 Gőzellátás, légkondicionálás`,
    teaorValue: '3530'
  },
  {
    labelText: `3600 '08 Víztermelés, -kezelés, -ellátás`,
    teaorValue: '3600'
  },
  {
    labelText: `3700 '08 Szennyvíz gyűjtése, kezelése`,
    teaorValue: '3700'
  },
  {
    labelText: `3811 '08 Nem veszélyes hulladék gyűjtése`,
    teaorValue: '3811'
  },
  {
    labelText: `3812 '08 Veszélyes hulladék gyűjtése`,
    teaorValue: '3812'
  },
  {
    labelText: `3821 '08 Nem veszélyes hulladék kezelése, ártalmatlanítása`,
    teaorValue: '3821'
  },
  {
    labelText: `3822 '08 Veszélyes hulladék kezelése, ártalmatlanítása`,
    teaorValue: '3822'
  },
  {
    labelText: `3831 '08 Használt eszköz bontása`,
    teaorValue: '3831'
  },
  {
    labelText: `3832 '08 Hulladék újrahasznosítása`,
    teaorValue: '3832'
  },
  {
    labelText: `3900 '08 Szennyeződésmentesítés, egyéb hulladékkezelés`,
    teaorValue: '3900'
  },
  {
    labelText: `4110 '08 Épületépítési projekt szervezése`,
    teaorValue: '4110'
  },
  {
    labelText: `4120 '08 Lakó- és nem lakó épület építése`,
    teaorValue: '4120'
  },
  {
    labelText: `4211 '08 Út, autópálya építése`,
    teaorValue: '4211'
  },
  {
    labelText: `4212 '08 Vasút építése`,
    teaorValue: '4212'
  },
  {
    labelText: `4213 '08 Híd, alagút építése`,
    teaorValue: '4213'
  },
  {
    labelText: `4221 '08 Folyadék szállítására szolgáló közmű építése`,
    teaorValue: '4221'
  },
  {
    labelText: `4222 '08 Elektromos, híradás-technikai célú közmű építése`,
    teaorValue: '4222'
  },
  {
    labelText: `4291 '08 Vízi létesítmény építése`,
    teaorValue: '4291'
  },
  {
    labelText: `4299 '08 Egyéb m.n.s. építés`,
    teaorValue: '4299'
  },
  {
    labelText: `4311 '08 Bontás`,
    teaorValue: '4311'
  },
  {
    labelText: `4312 '08 Építési terület előkészítése`,
    teaorValue: '4312'
  },
  {
    labelText: `4313 '08 Talajmintavétel, próbafúrás`,
    teaorValue: '4313'
  },
  {
    labelText: `4321 '08 Villanyszerelés`,
    teaorValue: '4321'
  },
  {
    labelText: `4322 '08 Víz-, gáz-, fűtés-, légkondicionáló-szerelés`,
    teaorValue: '4322'
  },
  {
    labelText: `4329 '08 Egyéb épületgépészeti szerelés`,
    teaorValue: '4329'
  },
  {
    labelText: `4331 '08 Vakolás`,
    teaorValue: '4331'
  },
  {
    labelText: `4332 '08 Épületasztalos-szerkezet szerelése`,
    teaorValue: '4332'
  },
  {
    labelText: `4333 '08 Padló-, falburkolás`,
    teaorValue: '4333'
  },
  {
    labelText: `4334 '08 Festés, üvegezés`,
    teaorValue: '4334'
  },
  {
    labelText: `4339 '08 Egyéb befejező építés m.n.s.`,
    teaorValue: '4339'
  },
  {
    labelText: `4391 '08 Tetőfedés, tetőszerkezet-építés`,
    teaorValue: '4391'
  },
  {
    labelText: `4399 '08 Egyéb speciális szaképítés m.n.s.`,
    teaorValue: '4399'
  },
  {
    labelText: `4511 '08 Személygépjármű-, könnyűgépjármű-kereskedelem`,
    teaorValue: '4511'
  },
  {
    labelText: `4519 '08 Egyéb gépjármű-kereskedelem`,
    teaorValue: '4519'
  },
  {
    labelText: `4520 '08 Gépjárműjavítás, -karbantartás`,
    teaorValue: '4520'
  },
  {
    labelText: `4531 '08 Gépjárműalkatrész-nagykereskedelem`,
    teaorValue: '4531'
  },
  {
    labelText: `4532 '08 Gépjárműalkatrész-kiskereskedelem`,
    teaorValue: '4532'
  },
  {
    labelText: `4540 '08 Motorkerékpár, -alkatrész kereskedelme, javítása`,
    teaorValue: '4540'
  },
  {
    labelText: `4611 '08 Mezőgazdasági termék ügynöki nagykereskedelme`,
    teaorValue: '4611'
  },
  {
    labelText: `4612 '08 Alapanyag, üzemanyag ügynöki nagykereskedelme`,
    teaorValue: '4612'
  },
  {
    labelText: `4613 '08 Fa-, építési anyag ügynöki nagykereskedelme`,
    teaorValue: '4613'
  },
  {
    labelText: `4614 '08 Gép, hajó, repülőgép ügynöki nagykereskedelme`,
    teaorValue: '4614'
  },
  {
    labelText: `4615 '08 Bútor, háztartási áru, fémáru ügynöki nagykereskedelme`,
    teaorValue: '4615'
  },
  {
    labelText: `4616 '08 Textil, ruházat, lábbeli, bőráru ügynöki nagykereskedelme`,
    teaorValue: '4616'
  },
  {
    labelText: `4617 '08 Élelmiszer, ital, dohányáru ügynöki nagykereskedelme`,
    teaorValue: '4617'
  },
  {
    labelText: `4618 '08 Egyéb termék ügynöki nagykereskedelme`,
    teaorValue: '4618'
  },
  {
    labelText: `4619 '08 Vegyes termékkörű ügynöki nagykereskedelem`,
    teaorValue: '4619'
  },
  {
    labelText: `4621 '08 Gabona, dohány, vetőmag, takarmány nagykereskedelme`,
    teaorValue: '4621'
  },
  {
    labelText: `4622 '08 Dísznövény nagykereskedelme`,
    teaorValue: '4622'
  },
  {
    labelText: `4623 '08 Élőállat nagykereskedelme`,
    teaorValue: '4623'
  },
  {
    labelText: `4624 '08 Bőr nagykereskedelme`,
    teaorValue: '4624'
  },
  {
    labelText: `4631 '08 Zöldség-, gyümölcs-nagykereskedelem`,
    teaorValue: '4631'
  },
  {
    labelText: `4632 '08 Hús-, húskészítmény nagykereskedelme`,
    teaorValue: '4632'
  },
  {
    labelText: `4633 '08 Tejtermék, tojás, zsiradék nagykereskedelme`,
    teaorValue: '4633'
  },
  {
    labelText: `4634 '08 Ital nagykereskedelme`,
    teaorValue: '4634'
  },
  {
    labelText: `4635 '08 Dohányáru nagykereskedelme`,
    teaorValue: '4635'
  },
  {
    labelText: `4636 '08 Cukor, édesség nagykereskedelme`,
    teaorValue: '4636'
  },
  {
    labelText: `4637 '08 Kávé-, tea-, kakaó-, fűszer-nagykereskedelem`,
    teaorValue: '4637'
  },
  {
    labelText: `4638 '08 Egyéb élelmiszer nagykereskedelme`,
    teaorValue: '4638'
  },
  {
    labelText: `4639 '08 Élelmiszer, ital, dohányáru vegyes nagykereskedelme`,
    teaorValue: '4639'
  },
  {
    labelText: `4641 '08 Textil-nagykereskedelem`,
    teaorValue: '4641'
  },
  {
    labelText: `4642 '08 Ruházat, lábbeli nagykereskedelme`,
    teaorValue: '4642'
  },
  {
    labelText: `4643 '08 Elektronikus háztartási cikk nagykereskedelme`,
    teaorValue: '4643'
  },
  {
    labelText: `4644 '08 Porcelán-, üvegáru-, tisztítószer-nagykereskedelem`,
    teaorValue: '4644'
  },
  {
    labelText: `4645 '08 Illatszer nagykereskedelme`,
    teaorValue: '4645'
  },
  {
    labelText: `4646 '08 Gyógyszer, gyógyászati termék nagykereskedelme`,
    teaorValue: '4646'
  },
  {
    labelText: `4647 '08 Bútor, szőnyeg, világítóberendezés nagykereskedelme`,
    teaorValue: '4647'
  },
  {
    labelText: `4648 '08 Óra-, ékszer-nagykereskedelem`,
    teaorValue: '4648'
  },
  {
    labelText: `4649 '08 Egyéb háztartási cikk nagykereskedelme m.n.s.`,
    teaorValue: '4649'
  },
  {
    labelText: `4651 '08 Számítógép, periféria, szoftver nagykereskedelme`,
    teaorValue: '4651'
  },
  {
    labelText: `4652 '08 Elektronikus, híradás-technikai berendezés, és alkatrészei nagykereskedelme`,
    teaorValue: '4652'
  },
  {
    labelText: `4661 '08 Mezőgazdasági gép, berendezés nagykereskedelme`,
    teaorValue: '4661'
  },
  {
    labelText: `4662 '08 Szerszámgép-nagykereskedelem`,
    teaorValue: '4662'
  },
  {
    labelText: `4663 '08 Bányászati-, építőipari gép nagykereskedelme`,
    teaorValue: '4663'
  },
  {
    labelText: `4664 '08 Textilipari gép, varró-, kötőgép nagykereskedelme`,
    teaorValue: '4664'
  },
  {
    labelText: `4665 '08 Irodabútor-nagykereskedelem`,
    teaorValue: '4665'
  },
  {
    labelText: `4666 '08 Egyéb irodagép, -berendezés nagykereskedelme`,
    teaorValue: '4666'
  },
  {
    labelText: `4669 '08 Egyéb m.n.s. gép, berendezés nagykereskedelme`,
    teaorValue: '4669'
  },
  {
    labelText: `4671 '08 Üzem-, tüzelőanyag nagykereskedelme`,
    teaorValue: '4671'
  },
  {
    labelText: `4672 '08 Fém-, érc-nagykereskedelem`,
    teaorValue: '4672'
  },
  {
    labelText: `4673 '08 Fa-, építőanyag-, szaniteráru-nagykereskedelem`,
    teaorValue: '4673'
  },
  {
    labelText: `4674 '08 Fémáru, szerelvény, fűtési berendezés nagykereskedelme`,
    teaorValue: '4674'
  },
  {
    labelText: `4675 '08 Vegyi áru nagykereskedelme`,
    teaorValue: '4675'
  },
  {
    labelText: `4676 '08 Egyéb termelési célú termék nagykereskedelme`,
    teaorValue: '4676'
  },
  {
    labelText: `4677 '08 Hulladék-nagykereskedelem`,
    teaorValue: '4677'
  },
  {
    labelText: `4690 '08 Vegyestermékkörű nagykereskedelem`,
    teaorValue: '4690'
  },
  {
    labelText: `4711 '08 Élelmiszer jellegű bolti vegyes kiskereskedelem`,
    teaorValue: '4711'
  },
  {
    labelText: `4719 '08 Iparcikk jellegű bolti vegyes kiskereskedelem`,
    teaorValue: '4719'
  },
  {
    labelText: `4721 '08 Zöldség, gyümölcs kiskereskedelme`,
    teaorValue: '4721'
  },
  {
    labelText: `4722 '08 Hús-, húsáru kiskereskedelme`,
    teaorValue: '4722'
  },
  {
    labelText: `4723 '08 Hal kiskereskedelme`,
    teaorValue: '4723'
  },
  {
    labelText: `4724 '08 Kenyér-, pékáru-, édesség-kiskereskedelem`,
    teaorValue: '4724'
  },
  {
    labelText: `4725 '08 Ital-kiskereskedelem`,
    teaorValue: '4725'
  },
  {
    labelText: `4726 '08 Dohányáru-kiskereskedelem`,
    teaorValue: '4726'
  },
  {
    labelText: `4729 '08 Egyéb élelmiszer-kiskereskedelem`,
    teaorValue: '4729'
  },
  {
    labelText: `4730 '08 Gépjárműüzemanyag-kiskereskedelem`,
    teaorValue: '4730'
  },
  {
    labelText: `4741 '08 Számítógép, periféria, szoftver kiskereskedelme`,
    teaorValue: '4741'
  },
  {
    labelText: `4742 '08 Telekommunikációs termék kiskereskedelme`,
    teaorValue: '4742'
  },
  {
    labelText: `4743 '08 Audio-, videoberendezés kiskereskedelme`,
    teaorValue: '4743'
  },
  {
    labelText: `4751 '08 Textil-kiskereskedelem`,
    teaorValue: '4751'
  },
  {
    labelText: `4752 '08 Vasáru-, festék-, üveg-kiskereskedelem`,
    teaorValue: '4752'
  },
  {
    labelText: `4753 '08 Takaró, szőnyeg, fal-, padlóburkoló kiskereskedelme`,
    teaorValue: '4753'
  },
  {
    labelText: `4754 '08 Villamos háztartási készülék kiskereskedelme`,
    teaorValue: '4754'
  },
  {
    labelText: `4759 '08 Bútor, világítási eszköz, egyéb háztartási cikk kiskereskedelme`,
    teaorValue: '4759'
  },
  {
    labelText: `4761 '08 Könyv-kiskereskedelem`,
    teaorValue: '4761'
  },
  {
    labelText: `4762 '08 Újság-, papíráru-kiskereskedelem`,
    teaorValue: '4762'
  },
  {
    labelText: `4763 '08 Zene-, videofelvétel kiskereskedelme`,
    teaorValue: '4763'
  },
  {
    labelText: `4764 '08 Sportszer-kiskereskedelem`,
    teaorValue: '4764'
  },
  {
    labelText: `4765 '08 Játék-kiskereskedelem`,
    teaorValue: '4765'
  },
  {
    labelText: `4771 '08 Ruházat kiskereskedelem`,
    teaorValue: '4771'
  },
  {
    labelText: `4772 '08 Lábbeli-, bőráru-kiskereskedelem`,
    teaorValue: '4772'
  },
  {
    labelText: `4773 '08 Gyógyszer-kiskereskedelem`,
    teaorValue: '4773'
  },
  {
    labelText: `4774 '08 Gyógyászati termék kiskereskedelme`,
    teaorValue: '4774'
  },
  {
    labelText: `4775 '08 Illatszer-kiskereskedelem`,
    teaorValue: '4775'
  },
  {
    labelText: `4776 '08 Dísznövény, vetőmag, műtrágya, hobbiállat-eledel kiskereskedelme`,
    teaorValue: '4776'
  },
  {
    labelText: `4777 '08 Óra-, ékszer-kiskereskedelem`,
    teaorValue: '4777'
  },
  {
    labelText: `4778 '08 Egyéb m.n.s. új áru kiskereskedelme`,
    teaorValue: '4778'
  },
  {
    labelText: `4779 '08 Használtcikk bolti kiskereskedelme`,
    teaorValue: '4779'
  },
  {
    labelText: `4781 '08 Élelmiszer, ital, dohányáru piaci kiskereskedelme`,
    teaorValue: '4781'
  },
  {
    labelText: `4782 '08 Textil, ruházat, lábbeli piaci kiskereskedelme`,
    teaorValue: '4782'
  },
  {
    labelText: `4789 '08 Egyéb áruk piaci kiskereskedelme`,
    teaorValue: '4789'
  },
  {
    labelText: `4791 '08 Csomagküldő, internetes kiskereskedelem`,
    teaorValue: '4791'
  },
  {
    labelText: `4799 '08 Egyéb nem bolti, piaci kiskereskedelem`,
    teaorValue: '4799'
  },
  {
    labelText: `4910 '08 Helyközi vasúti személyszállítás`,
    teaorValue: '4910'
  },
  {
    labelText: `4920 '08 Vasúti áruszállítás`,
    teaorValue: '4920'
  },
  {
    labelText: `4931 '08 Városi, elővárosi szárazföldi személyszállítás`,
    teaorValue: '4931'
  },
  {
    labelText: `4932 '08 Taxis személyszállítás`,
    teaorValue: '4932'
  },
  {
    labelText: `4939 '08 M.n.s. egyéb szárazföldi személyszállítás`,
    teaorValue: '4939'
  },
  {
    labelText: `4941 '08 Közúti áruszállítás`,
    teaorValue: '4941'
  },
  {
    labelText: `4942 '08 Költöztetés`,
    teaorValue: '4942'
  },
  {
    labelText: `4950 '08 Csővezetékes szállítás`,
    teaorValue: '4950'
  },
  {
    labelText: `5010 '08 Tengeri személyszállítás`,
    teaorValue: '5010'
  },
  {
    labelText: `5020 '08 Tengeri áruszállítás`,
    teaorValue: '5020'
  },
  {
    labelText: `5030 '08 Belvízi személyszállítás`,
    teaorValue: '5030'
  },
  {
    labelText: `5040 '08 Belvízi áruszállítás`,
    teaorValue: '5040'
  },
  {
    labelText: `5110 '08 Légi személyszállítás`,
    teaorValue: '5110'
  },
  {
    labelText: `5121 '08 Légi áruszállítás`,
    teaorValue: '5121'
  },
  {
    labelText: `5122 '08 Űrszállítás`,
    teaorValue: '5122'
  },
  {
    labelText: `5210 '08 Raktározás, tárolás`,
    teaorValue: '5210'
  },
  {
    labelText: `5221 '08 Szárazföldi szállítást kiegészítő szolgáltatás`,
    teaorValue: '5221'
  },
  {
    labelText: `5222 '08 Vízi szállítást kiegészítő szolgáltatás`,
    teaorValue: '5222'
  },
  {
    labelText: `5223 '08 Légi szállítást kiegészítő szolgáltatás`,
    teaorValue: '5223'
  },
  {
    labelText: `5224 '08 Rakománykezelés`,
    teaorValue: '5224'
  },
  {
    labelText: `5229 '08 Egyéb szállítást kiegészítő szolgáltatás`,
    teaorValue: '5229'
  },
  {
    labelText: `5310 '08 Postai tevékenység (egyetemes kötelezettséggel)`,
    teaorValue: '5310'
  },
  {
    labelText: `5320 '08 Egyéb postai, futárpostai tevékenység`,
    teaorValue: '5320'
  },
  {
    labelText: `5510 '08 Szállodai szolgáltatás`,
    teaorValue: '5510'
  },
  {
    labelText: `5520 '08 Üdülési, egyéb átmeneti szálláshely-szolgáltatás`,
    teaorValue: '5520'
  },
  {
    labelText: `5530 '08 Kempingszolgáltatás`,
    teaorValue: '5530'
  },
  {
    labelText: `5590 '08 Egyéb szálláshely-szolgáltatás`,
    teaorValue: '5590'
  },
  {
    labelText: `5610 '08 Éttermi, mozgó vendéglátás`,
    teaorValue: '5610'
  },
  {
    labelText: `5621 '08 Rendezvényi étkeztetés`,
    teaorValue: '5621'
  },
  {
    labelText: `5629 '08 Egyéb vendéglátás`,
    teaorValue: '5629'
  },
  {
    labelText: `5630 '08 Italszolgáltatás`,
    teaorValue: '5630'
  },
  {
    labelText: `5811 '08 Könyvkiadás`,
    teaorValue: '5811'
  },
  {
    labelText: `5812 '08 Címtárak, levelezőjegyzékek kiadása`,
    teaorValue: '5812'
  },
  {
    labelText: `5813 '08 Napilapkiadás`,
    teaorValue: '5813'
  },
  {
    labelText: `5814 '08 Folyóirat, időszaki kiadvány kiadása`,
    teaorValue: '5814'
  },
  {
    labelText: `5819 '08 Egyéb kiadói tevékenység`,
    teaorValue: '5819'
  },
  {
    labelText: `5821 '08 Számítógépes játék kiadása`,
    teaorValue: '5821'
  },
  {
    labelText: `5829 '08 Egyéb szoftverkiadás`,
    teaorValue: '5829'
  },
  {
    labelText: `5911 '08 Film-, video-, televízióműsor-gyártás`,
    teaorValue: '5911'
  },
  {
    labelText: `5912 '08 Film-, videogyártás, televíziós műsorfelvétel utómunkálatai`,
    teaorValue: '5912'
  },
  {
    labelText: `5913 '08 Film-, video- és televízióprogram terjesztése`,
    teaorValue: '5913'
  },
  {
    labelText: `5914 '08 Filmvetítés`,
    teaorValue: '5914'
  },
  {
    labelText: `5920 '08 Hangfelvétel készítése, kiadása`,
    teaorValue: '5920'
  },
  {
    labelText: `6010 '08 Rádióműsor-szolgáltatás`,
    teaorValue: '6010'
  },
  {
    labelText: `6020 '08 Televízióműsor összeállítása, szolgáltatása`,
    teaorValue: '6020'
  },
  {
    labelText: `6110 '08 Vezetékes távközlés`,
    teaorValue: '6110'
  },
  {
    labelText: `6120 '08 Vezeték nélküli távközlés`,
    teaorValue: '6120'
  },
  {
    labelText: `6130 '08 Műholdas távközlés`,
    teaorValue: '6130'
  },
  {
    labelText: `6190 '08 Egyéb távközlés`,
    teaorValue: '6190'
  },
  {
    labelText: `6201 '08 Számítógépes programozás`,
    teaorValue: '6201'
  },
  {
    labelText: `6202 '08 Információ-technológiai szaktanácsadás`,
    teaorValue: '6202'
  },
  {
    labelText: `6203 '08 Számítógép-üzemeltetés`,
    teaorValue: '6203'
  },
  {
    labelText: `6209 '08 Egyéb információ-technológiai szolgáltatás`,
    teaorValue: '6209'
  },
  {
    labelText: `6311 '08 Adatfeldolgozás, web-hoszting szolgáltatás`,
    teaorValue: '6311'
  },
  {
    labelText: `6312 '08 Világháló-portál szolgáltatás`,
    teaorValue: '6312'
  },
  {
    labelText: `6391 '08 Hírügynökségi tevékenység`,
    teaorValue: '6391'
  },
  {
    labelText: `6399 '08 M.n.s. egyéb információs szolgáltatás`,
    teaorValue: '6399'
  },
  {
    labelText: `6411 '08 Jegybanki tevékenység`,
    teaorValue: '6411'
  },
  {
    labelText: `6419 '08 Egyéb monetáris közvetítés`,
    teaorValue: '6419'
  },
  {
    labelText: `6420 '08 Vagyonkezelés (holding)`,
    teaorValue: '6420'
  },
  {
    labelText: `6430 '08 Befektetési alapok és hasonlók`,
    teaorValue: '6430'
  },
  {
    labelText: `6491 '08 Pénzügyi lízing`,
    teaorValue: '6491'
  },
  {
    labelText: `6492 '08 Egyéb hitelnyújtás`,
    teaorValue: '6492'
  },
  {
    labelText: `6499 '08 M.n.s. egyéb pénzügyi közvetítés`,
    teaorValue: '6499'
  },
  {
    labelText: `6511 '08 Életbiztosítás`,
    teaorValue: '6511'
  },
  {
    labelText: `6512 '08 Nem életbiztosítás`,
    teaorValue: '6512'
  },
  {
    labelText: `6520 '08 Viszontbiztosítás`,
    teaorValue: '6520'
  },
  {
    labelText: `6530 '08 Nyugdíjalapok`,
    teaorValue: '6530'
  },
  {
    labelText: `6611 '08 Pénz-, tőkepiac igazgatása`,
    teaorValue: '6611'
  },
  {
    labelText: `6612 '08 Értékpapír-, árutőzsdei ügynöki tevékenység`,
    teaorValue: '6612'
  },
  {
    labelText: `6619 '08 Egyéb pénzügyi kiegészítő tevékenység`,
    teaorValue: '6619'
  },
  {
    labelText: `6621 '08 Kockázatértékelés, kárszakértés`,
    teaorValue: '6621'
  },
  {
    labelText: `6622 '08 Biztosítási ügynöki, brókeri tevékenység`,
    teaorValue: '6622'
  },
  {
    labelText: `6629 '08 Biztosítás, nyugdíjalap egyéb kiegészítő tevékenysége`,
    teaorValue: '6629'
  },
  {
    labelText: `6630 '08 Alapkezelés`,
    teaorValue: '6630'
  },
  {
    labelText: `6810 '08 Saját tulajdonú ingatlan adásvétele`,
    teaorValue: '6810'
  },
  {
    labelText: `6820 '08 Saját tulajdonú, bérelt ingatlan bérbeadása, üzemeltetése`,
    teaorValue: '6820'
  },
  {
    labelText: `6831 '08 Ingatlanügynöki tevékenység`,
    teaorValue: '6831'
  },
  {
    labelText: `6832 '08 Ingatlankezelés`,
    teaorValue: '6832'
  },
  {
    labelText: `6910 '08 Jogi tevékenység`,
    teaorValue: '6910'
  },
  {
    labelText: `6920 '08 Számviteli, könyvvizsgálói, adószakértői tevékenység`,
    teaorValue: '6920'
  },
  {
    labelText: `7010 '08 Üzletvezetés`,
    teaorValue: '7010'
  },
  {
    labelText: `7021 '08 PR, kommunikáció`,
    teaorValue: '7021'
  },
  {
    labelText: `7022 '08 Üzletviteli, egyéb vezetési tanácsadás`,
    teaorValue: '7022'
  },
  {
    labelText: `7111 '08 Építészmérnöki tevékenység`,
    teaorValue: '7111'
  },
  {
    labelText: `7112 '08 Mérnöki tevékenység, műszaki tanácsadás`,
    teaorValue: '7112'
  },
  {
    labelText: `7120 '08 Műszaki vizsgálat, elemzés`,
    teaorValue: '7120'
  },
  {
    labelText: `7211 '08 Biotechnológiai kutatás, fejlesztés`,
    teaorValue: '7211'
  },
  {
    labelText: `7219 '08 Egyéb természettudományi, műszaki kutatás, fejlesztés`,
    teaorValue: '7219'
  },
  {
    labelText: `7220 '08 Társadalomtudományi, humán kutatás, fejlesztés`,
    teaorValue: '7220'
  },
  {
    labelText: `7311 '08 Reklámügynöki tevékenység`,
    teaorValue: '7311'
  },
  {
    labelText: `7312 '08 Médiareklám`,
    teaorValue: '7312'
  },
  {
    labelText: `7320 '08 Piac-, közvélemény-kutatás`,
    teaorValue: '7320'
  },
  {
    labelText: `7410 '08 Divat-, formatervezés`,
    teaorValue: '7410'
  },
  {
    labelText: `7420 '08 Fényképészet`,
    teaorValue: '7420'
  },
  {
    labelText: `7430 '08 Fordítás, tolmácsolás`,
    teaorValue: '7430'
  },
  {
    labelText: `7490 '08 M.n.s. egyéb szakmai, tudományos, műszaki tevékenység`,
    teaorValue: '7490'
  },
  {
    labelText: `7500 '08 Állat-egészségügyi ellátás`,
    teaorValue: '7500'
  },
  {
    labelText: `7711 '08 Személygépjármű kölcsönzése`,
    teaorValue: '7711'
  },
  {
    labelText: `7712 '08 Gépjárműkölcsönzés (3,5 tonna fölött)`,
    teaorValue: '7712'
  },
  {
    labelText: `7721 '08 Szabadidős, sporteszköz kölcsönzése`,
    teaorValue: '7721'
  },
  {
    labelText: `7722 '08 Videokazetta, lemez kölcsönzése`,
    teaorValue: '7722'
  },
  {
    labelText: `7729 '08 Egyéb személyi használatú, háztartási cikk kölcsönzése`,
    teaorValue: '7729'
  },
  {
    labelText: `7731 '08 Mezőgazdasági gép kölcsönzése`,
    teaorValue: '7731'
  },
  {
    labelText: `7732 '08 Építőipari gép kölcsönzése`,
    teaorValue: '7732'
  },
  {
    labelText: `7733 '08 Irodagép kölcsönzése (beleértve: számítógép)`,
    teaorValue: '7733'
  },
  {
    labelText: `7734 '08 Vízi szállítóeszköz kölcsönzése`,
    teaorValue: '7734'
  },
  {
    labelText: `7735 '08 Légi szállítóeszköz kölcsönzése`,
    teaorValue: '7735'
  },
  {
    labelText: `7739 '08 Egyéb gép, tárgyi eszköz kölcsönzése`,
    teaorValue: '7739'
  },
  {
    labelText: `7740 '08 Immateriális javak kölcsönzése`,
    teaorValue: '7740'
  },
  {
    labelText: `7810 '08 Munkaközvetítés`,
    teaorValue: '7810'
  },
  {
    labelText: `7820 '08 Munkaerőkölcsönzés`,
    teaorValue: '7820'
  },
  {
    labelText: `7830 '08 Egyéb emberierőforrás-ellátás, -gazdálkodás`,
    teaorValue: '7830'
  },
  {
    labelText: `7911 '08 Utazásközvetítés`,
    teaorValue: '7911'
  },
  {
    labelText: `7912 '08 Utazásszervezés`,
    teaorValue: '7912'
  },
  {
    labelText: `7990 '08 Egyéb foglalás`,
    teaorValue: '7990'
  },
  {
    labelText: `8010 '08 Személybiztonsági tevékenység`,
    teaorValue: '8010'
  },
  {
    labelText: `8020 '08 Biztonsági rendszer szolgáltatás`,
    teaorValue: '8020'
  },
  {
    labelText: `8030 '08 Nyomozás`,
    teaorValue: '8030'
  },
  {
    labelText: `8110 '08 Építményüzemeltetés`,
    teaorValue: '8110'
  },
  {
    labelText: `8121 '08 Általános épülettakarítás`,
    teaorValue: '8121'
  },
  {
    labelText: `8122 '08 Egyéb épület-, ipari takarítás`,
    teaorValue: '8122'
  },
  {
    labelText: `8129 '08 Egyéb takarítás`,
    teaorValue: '8129'
  },
  {
    labelText: `8130 '08 Zöldterület-kezelés`,
    teaorValue: '8130'
  },
  {
    labelText: `8211 '08 Összetett adminisztratív szolgáltatás`,
    teaorValue: '8211'
  },
  {
    labelText: `8219 '08 Fénymásolás, egyéb irodai szolgáltatás`,
    teaorValue: '8219'
  },
  {
    labelText: `8220 '08 Telefoninformáció`,
    teaorValue: '8220'
  },
  {
    labelText: `8230 '08 Konferencia, kereskedelmi bemutató szervezése`,
    teaorValue: '8230'
  },
  {
    labelText: `8291 '08 Követelésbehajtás`,
    teaorValue: '8291'
  },
  {
    labelText: `8292 '08 Csomagolás`,
    teaorValue: '8292'
  },
  {
    labelText: `8299 '08 M.n.s. egyéb kiegészítő üzleti szolgáltatás`,
    teaorValue: '8299'
  },
  {
    labelText: `8411 '08 Általános közigazgatás`,
    teaorValue: '8411'
  },
  {
    labelText: `8412 '08 Egészségügy, oktatás, kultúra, egyéb szociális szolgáltatás (kivéve: társadalombiztosítás) igazgatása`,
    teaorValue: '8412'
  },
  {
    labelText: `8413 '08 Üzleti élet szabályozása, hatékonyságának ösztönzése`,
    teaorValue: '8413'
  },
  {
    labelText: `8421 '08 Külügyek`,
    teaorValue: '8421'
  },
  {
    labelText: `8422 '08 Honvédelem`,
    teaorValue: '8422'
  },
  {
    labelText: `8423 '08 Igazságügy, bíróság`,
    teaorValue: '8423'
  },
  {
    labelText: `8424 '08 Közbiztonság, közrend`,
    teaorValue: '8424'
  },
  {
    labelText: `8425 '08 Tűzvédelem`,
    teaorValue: '8425'
  },
  {
    labelText: `8430 '08 Kötelező társadalombiztosítás`,
    teaorValue: '8430'
  },
  {
    labelText: `8510 '08 Iskolai előkészítő oktatás`,
    teaorValue: '8510'
  },
  {
    labelText: `8520 '08 Alapfokú oktatás`,
    teaorValue: '8520'
  },
  {
    labelText: `8531 '08 Általános középfokú oktatás`,
    teaorValue: '8531'
  },
  {
    labelText: `8532 '08 Szakmai középfokú oktatás`,
    teaorValue: '8532'
  },
  {
    labelText: `8541 '08 Felső szintű, nem felsőfokú oktatás`,
    teaorValue: '8541'
  },
  {
    labelText: `8542 '08 Felsőfokú oktatás`,
    teaorValue: '8542'
  },
  {
    labelText: `8551 '08 Sport, szabadidős képzés`,
    teaorValue: '8551'
  },
  {
    labelText: `8552 '08 Kulturális képzés`,
    teaorValue: '8552'
  },
  {
    labelText: `8553 '08 Járművezető-oktatás`,
    teaorValue: '8553'
  },
  {
    labelText: `8559 '08 M.n.s. egyéb oktatás`,
    teaorValue: '8559'
  },
  {
    labelText: `8560 '08 Oktatást kiegészítő tevékenység`,
    teaorValue: '8560'
  },
  {
    labelText: `8610 '08 Fekvőbeteg-ellátás`,
    teaorValue: '8610'
  },
  {
    labelText: `8621 '08 Általános járóbeteg-ellátás`,
    teaorValue: '8621'
  },
  {
    labelText: `8622 '08 Szakorvosi járóbeteg-ellátás`,
    teaorValue: '8622'
  },
  {
    labelText: `8623 '08 Fogorvosi járóbeteg-ellátás`,
    teaorValue: '8623'
  },
  {
    labelText: `8690 '08 Egyéb humán-egészségügyi ellátás`,
    teaorValue: '8690'
  },
  {
    labelText: `8710 '08 Bentlakásos, nem kórházi ápolás`,
    teaorValue: '8710'
  },
  {
    labelText: `8720 '08 Mentális, szenvedélybeteg bentlakásos ellátása`,
    teaorValue: '8720'
  },
  {
    labelText: `8730 '08 Idősek, fogyatékosok bentlakásos ellátása`,
    teaorValue: '8730'
  },
  {
    labelText: `8790 '08 Egyéb bentlakásos ellátás`,
    teaorValue: '8790'
  },
  {
    labelText: `8810 '08 Idősek, fogyatékosok szociális ellátása bentlakás nélkül`,
    teaorValue: '8810'
  },
  {
    labelText: `8891 '08 Gyermekek napközbeni ellátása`,
    teaorValue: '8891'
  },
  {
    labelText: `8899 '08 M.n.s. egyéb szociális ellátás bentlakás nélkül`,
    teaorValue: '8899'
  },
  {
    labelText: `9001 '08 Előadó-művészet`,
    teaorValue: '9001'
  },
  {
    labelText: `9002 '08 Előadó-művészetet kiegészítő tevékenység`,
    teaorValue: '9002'
  },
  {
    labelText: `9003 '08 Alkotóművészet`,
    teaorValue: '9003'
  },
  {
    labelText: `9004 '08 Művészeti létesítmények működtetése`,
    teaorValue: '9004'
  },
  {
    labelText: `9101 '08 Könyvtári, levéltári tevékenység`,
    teaorValue: '9101'
  },
  {
    labelText: `9102 '08 Múzeumi tevékenység`,
    teaorValue: '9102'
  },
  {
    labelText: `9103 '08 Történelmi hely, építmény, egyéb látványosság működtetése`,
    teaorValue: '9103'
  },
  {
    labelText: `9104 '08 Növény-, állatkert, természetvédelmi terület működtetése`,
    teaorValue: '9104'
  },
  {
    labelText: `9200 '08 Szerencsejáték, fogadás`,
    teaorValue: '9200'
  },
  {
    labelText: `9311 '08 Sportlétesítmény működtetése`,
    teaorValue: '9311'
  },
  {
    labelText: `9312 '08 Sportegyesületi tevékenység`,
    teaorValue: '9312'
  },
  {
    labelText: `9313 '08 Testedzési szolgáltatás`,
    teaorValue: '9313'
  },
  {
    labelText: `9319 '08 Egyéb sporttevékenység`,
    teaorValue: '9319'
  },
  {
    labelText: `9321 '08 Vidámparki, szórakoztatóparki tevékenység`,
    teaorValue: '9321'
  },
  {
    labelText: `9329 '08 M.n.s. egyéb szórakoztatás, szabadidős tevékenység`,
    teaorValue: '9329'
  },
  {
    labelText: `9411 '08 Vállalkozói, munkaadói érdekképviselet`,
    teaorValue: '9411'
  },
  {
    labelText: `9412 '08 Szakmai érdekképviselet`,
    teaorValue: '9412'
  },
  {
    labelText: `9420 '08 Szakszervezeti tevékenység`,
    teaorValue: '9420'
  },
  {
    labelText: `9491 '08 Egyházi tevékenység`,
    teaorValue: '9491'
  },
  {
    labelText: `9492 '08 Politikai tevékenység`,
    teaorValue: '9492'
  },
  {
    labelText: `9499 '08 M.n.s. egyéb közösségi, társadalmi tevékenység`,
    teaorValue: '9499'
  },
  {
    labelText: `9511 '08 Számítógép, -periféria javítása`,
    teaorValue: '9511'
  },
  {
    labelText: `9512 '08 Kommunikációs eszköz javítása`,
    teaorValue: '9512'
  },
  {
    labelText: `9521 '08 Szórakoztatóelektronikai cikk javítása`,
    teaorValue: '9521'
  },
  {
    labelText: `9522 '08 Háztartási gép, háztartási, kerti eszköz javítása`,
    teaorValue: '9522'
  },
  {
    labelText: `9523 '08 Lábbeli, egyéb bőráru javítása`,
    teaorValue: '9523'
  },
  {
    labelText: `9524 '08 Bútor, lakberendezési tárgy javítása`,
    teaorValue: '9524'
  },
  {
    labelText: `9525 '08 Óra-, ékszerjavítás`,
    teaorValue: '9525'
  },
  {
    labelText: `9529 '08 Egyéb személyi-, háztartási cikk javítása`,
    teaorValue: '9529'
  },
  {
    labelText: `9601 '08 Textil, szőrme mosása, tisztítása`,
    teaorValue: '9601'
  },
  {
    labelText: `9602 '08 Fodrászat, szépségápolás`,
    teaorValue: '9602'
  },
  {
    labelText: `9603 '08 Temetkezés, temetkezést kiegészítő szolgáltatás`,
    teaorValue: '9603'
  },
  {
    labelText: `9604 '08 Fizikai közérzetet javító szolgáltatás`,
    teaorValue: '9604'
  },
  {
    labelText: `9609 '08 M.n.s. egyéb személyi szolgáltatás`,
    teaorValue: '9609'
  },
  {
    labelText: `9700 '08 Háztartási alkalmazottat foglalkoztató magánháztartás`,
    teaorValue: '9700'
  },
  {
    labelText: `9810 '08 Háztartás termék-előállítása, szolgáltatása saját fogyasztásra`,
    teaorValue: '9810'
  },
  {
    labelText: `9820 '08 Háztartás szolgáltatása saját fogyasztásra`,
    teaorValue: '9820'
  }
]

export default fourDigitTeaors
